import {toDateFromServer} from '../../../../utils/formatter'
import {daysBetweenDates} from '../../../../utils/helper'
import moment from 'moment/moment'

export const makeAdultsCounter = (state) => {
  let adults = 0
  const {camere} = state.search
  if (!camere) return 0
  for (let i = 0; i < camere.length; i++) {
    adults += camere[i].adults
  }
  return adults
}

export const makeChildsCounter = (state) => {
  let childs = 0
  const {camere} = state.search
  if (!camere) return 0
  for (let i = 0; i < camere.length; i++) {
    childs += camere[i].childs.length
  }
  return childs
}

export const makeFlexibleDates = (state, periods) => {
  // console.log('makeFlexibleDates -----------------------')
  // console.log(periods)
  const list = periods.map(function (item) {
    const {period, flightAvailability} = item
    const {tariffaVenditaEuro, tasseVenditaEuro} = flightAvailability.totale
    const prezzoVendita = tariffaVenditaEuro + tasseVenditaEuro
    const start = toDateFromServer(period.start.date)
    const end = toDateFromServer(period.end.date)
    return {start, end, prezzoVendita}
  })
  return list.sort(function (a, b) {
    return a.start.getTime() - b.start.getTime()
  })
}

export const makeEmptyOrario = () => {
  return [{h: 0, m: 0}, {h: 24, m: 0}]
}

export const makeDays = (search) => {
  // console.log('makeDays -----------------------')
  // console.log(search)
  const days = daysBetweenDates(search.andata, search.ritorno) + 1
  let list = []
  for (let i = 0; i < days; i++) {
    list[i] = {day: moment(search.andata).add(i, 'days').toDate()}
  }
  return list
}

export const makeDaysFromDate = (departure, days) => {
  // console.log('makeDaysFromDate -----------------------')
  // console.log(departure)
  // console.log(days)
  let list = []
  for (let i = 0; i < days; i++) {
    list[i] = {day: moment(departure).add(i, 'days').toDate()}
  }
  return list
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/utils.js